<template>
  <footer class="footer">
    <div class="footer-content">
      <div class="footer-message">
        <!-- <span v-if="isOtherICP"
          ><a href="https://beian.miit.gov.cn/" target="_blank"
            >苏ICP备20045132号</a
          ></span
        >
        <span v-if="!isOtherICP"
          >粤公网安备 44010602007932号 粤ICP备15015917号</span
        ><span class="split">|</span> -->
        <span>Copyright © 2014 - 2021 广州六一信息科技有限公司 版权所有</span>
        <br />
        <span
          >联系地址：广州市中山大道天辉商业大厦；联系电话：400-6161-023；联系邮箱：kefu@61info.cn</span
        >
      </div>
    </div>
  </footer>
</template>

<script>
import { isOtherICP } from '../../util'
export default {
  name: 'Footer',
  data: function () {
    return {
      isOtherICP: isOtherICP(),
    }
  },
}
</script>

<style lang="scss" scoped>
@import './index.scss';
</style>
